import { create } from 'zustand'
import createMenusSlice, { MenusSlice } from './slice'
import { devtools } from 'zustand/middleware'

export * from './slice'

const useMenusStore = create<MenusSlice>()(
  devtools(
    (...props) => ({
      ...createMenusSlice(...props),
    }),
    { enabled: process.env.NODE_ENV === 'development', name: 'Menus Store' }
  )
)

export default useMenusStore
